import React from "react";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { RootState } from "../../../../store";

import { Employee } from "../../../../interfaces/User";
import { ServiceProvider } from "../../../../interfaces/ServiceProvidersInterface";
import { getGenderString } from "../../../Campaign/Audience/AudienceHelpers";
import { CalendarFunctions } from "../../../../components/Calendar";

interface PropType {
  employee: Employee | ServiceProvider | null;
}

// data, functions and components
export function InfoRow({
  label,
  value,
  color
}: {
  label: string;
  value: string | number;
  color?: string;
}): React.ReactNode {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography color="text.secondary" sx={{ minWidth: 100, fontSize: 12 }}>
        {label}
      </Typography>
      <Typography sx={{ fontWeight: 600, color: color || "text.primary", fontSize: 12 }}>
        : {value}
      </Typography>
    </Box>
  );
}

export default function SelectedEmployee({ employee }: PropType): React.ReactNode {
  const departments = useSelector((state: RootState) => state.departments);
  if (!employee) return <></>;

  // department name
  const departmentName = employee?.departmentId
    ? departments.find((dept) => String(dept.id) === String(employee.departmentId))?.name || "N/A"
    : "N/A";

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2
        }}
      >
        <Box sx={{ bgcolor: "#fafbfc", border: "1px solid #eee", borderRadius: 2, p: 2 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: 0
            }}
          >
            <InfoRow label="Name:" value={`${employee.firstName} ${employee.lastName}` || "N/A"} />
            <InfoRow label="Department" value={departmentName || "N/A"} />
            <InfoRow label="Designation" value={employee?.designation || "N/A"} />
            <InfoRow
              label="Gender"
              value={employee?.gender ? getGenderString(employee.gender) : "N/A"}
            />
            <InfoRow label="Marital Status" value={employee?.maritalStatus || "N/A"} />
            <InfoRow label="Tax Opted Status" value={employee?.taxOptedStatus || "N/A"} />
            {employee?.dateOfJoining && (
              <InfoRow
                label="Date of Joining"
                value={CalendarFunctions.convertADtoBS(new Date(employee.dateOfJoining)).formatted}
              />
            )}
            {employee?.activeCtc && (
              <InfoRow
                label="CTC Effective From"
                value={
                  CalendarFunctions.convertADtoBS(new Date(employee.activeCtc?.effectiveFrom))
                    .formatted
                }
              />
            )}
          </Box>
        </Box>
      </Box>
    </div>
  );
}
